module.exports = {"id":"157960","name":"Manuel Fernandes","rating":"81","photo":"./data/images/photos/3/157960.png","club":{"name":"Lokomotiv Moscou","logo":"./data/images/clubs/LokomotivMoscou.png"},"positions":["MOC","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ManuelFernandes0.json
// module id = 2679
// module chunks = 0